import { addHourToHour } from "../../services/date";

const Totals = ({ data }: { data: any }) => {
    
    const total = data?.reduce((acc: string, item: any) => {
        // Vérifier que item.length est une chaîne de caractères au format "HH:MM"
        if (typeof item.length === 'string' && item.length.includes(':')) {
            return addHourToHour(acc, item.length);
        }
        return acc;
    }, "00:00");

    return (
      <div className="flex shrink-0 items-center justify-end gap-3 border-t border-slate-200 bg-slate-50/70 px-4 py-3 font-Nunito sm:px-5">
        <span className="text-[11px] font-bold tracking-wider text-slate-400 uppercase">
          Total
        </span>
        <span className="text-base font-bold text-slate-900 tabular-nums">
          {total}
        </span>
      </div>
    )
  }
  
  export default Totals
  